import { PrevProjDataOptions } from "@/data-types/api/epidemiologyData.types";

export const formatPrevProjOptionsBody = (values: any): PrevProjDataOptions | null => {
  if (!values) return null;
  return {
    startPeriodYear: Number(values?.startPeriodYear),
    lastPeriodYear: Number(values?.lastPeriodYear),
    periodYearStep: Number(values?.periodYearStep),
  };
};
